module.exports = __webpack_public_path__ + "static/media/rolls-royce-go-drive.dc7549c4.png";